import api from '../../lib/api';
import type { RiskCatalogItem, RiskCatalogKind } from './types';

export const fetchCatalogItems = async (
  kind: RiskCatalogKind,
  active?: boolean,
): Promise<RiskCatalogItem[]> => {
  const { data } = await api.get<RiskCatalogItem[]>('risk-catalog', {
    params: { kind, active },
  });
  return data;
};

export const createCatalogItem = async (payload: {
  kind: RiskCatalogKind;
  label: string;
  sortOrder?: number;
}): Promise<RiskCatalogItem> => {
  const { data } = await api.post<RiskCatalogItem>('risk-catalog', payload);
  return data;
};

export const updateCatalogItem = async (
  id: string,
  payload: { label?: string; sortOrder?: number; active?: boolean },
): Promise<RiskCatalogItem> => {
  const { data } = await api.put<RiskCatalogItem>(`risk-catalog/${id}`, payload);
  return data;
};

export const mergeCatalogItems = async (
  fromId: string,
  toId: string,
): Promise<RiskCatalogItem> => {
  const { data } = await api.post<RiskCatalogItem>('risk-catalog/merge', { fromId, toId });
  return data;
};

export const deleteCatalogItem = async (id: string): Promise<void> => {
  await api.delete(`risk-catalog/${id}`);
};
